import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [RouterLink, ButtonModule],
  template: `
    <main class="page-shell">
      <section class="panel">
        <h1>Forbidden</h1>
        <p class="muted">Your account is authenticated but does not have permission for this admin route.</p>
        <p-button label="Back to dashboard" severity="secondary" [outlined]="true" routerLink="/dashboard" />
      </section>
    </main>
  `,
})
export class ForbiddenComponent {}
